import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";
import FitGuideButton from "../fitGuideButton/FitGuideButton";
import { FitType, ProductData } from "../../types/productTypes/product";

type RuntimeConstants = {
  product?: ProductData;
  webContext?: {
    browseLanguage?: string;
    browseCountry?: string;
    keyStoreDataversion?: string;
  };
  storeCode?: string;
  getTranslation?: (
    key: string,
    params?: Record<string, string>,
    locale?: string
  ) => string;
  fitGuideUrl?: string | null;
};

const fitTypeIdToTranslationKey: Record<number, string> = {
  53000: "fit_guide_muscle_fit",
  61452: "fit_guide_slim_fit",
  53002: "fit_guide_regular_fit",
  53003: "fit_guide_relaxed_fit",
  53001: "fit_guide_oversized_fit",
  75753: "fit_guide_boxy_oversized_fit",
};
const fitGuideBrandsIds = [53, 15878, 12769, 16236, 15643, 63177];
const fitGuideProductTypeIds = [8415, 10888];
const fitGuideGenders = ["men"];

type ShouldShowFitGuideParams = {
  brandId: number | null;
  productTypeId: number | null;
  gender: string | null;
  fitType: FitType | null;
  fitGuideUrl: string | null;
};

function shouldShowFitGuide({
  brandId,
  productTypeId,
  gender,
  fitType,
  fitGuideUrl,
}: ShouldShowFitGuideParams): boolean {
  return !!(
    fitGuideUrl &&
    brandId &&
    productTypeId &&
    gender &&
    fitType &&
    fitType.id in fitTypeIdToTranslationKey &&
    fitGuideBrandsIds.includes(brandId) &&
    fitGuideProductTypeIds.includes(productTypeId) &&
    fitGuideGenders.includes(gender.toLowerCase())
  );
}

export default function FitGuideContainer() {
  const runtime = useRuntimeConstants() as RuntimeConstants;
  const brandId = runtime.product?.brandId ?? null;
  const productTypeId = runtime.product?.productType?.id ?? null;
  const gender = runtime.product?.gender ?? null;
  const fitType = runtime.product?.fitType ?? null;
  const browseLanguage = runtime.webContext?.browseLanguage;
  const browseCountry = runtime.webContext?.browseCountry;
  const keyStoreDataversion = runtime.webContext?.keyStoreDataversion;
  const storeCode = runtime.storeCode ?? "";
  const getTranslation = runtime.getTranslation ?? (() => "");
  const fitGuideUrl = runtime.fitGuideUrl ?? null;

  return shouldShowFitGuide({
    brandId,
    productTypeId,
    gender,
    fitType,
    fitGuideUrl,
  }) ? (
    <>
      {". "}
      <FitGuideButton
        fitTypeId={fitType!.id}
        fitTypeCopyKey={fitTypeIdToTranslationKey[fitType!.id]}
        productTypeId={productTypeId!}
        brandId={brandId!}
        browseLanguage={browseLanguage}
        browseCountry={browseCountry}
        storeCode={storeCode}
        keyStoreDataVersion={keyStoreDataversion}
        gender={gender!}
        fitGuideUrl={fitGuideUrl!}
        getTranslation={getTranslation}
      />
    </>
  ) : null;
}
